'use strict';

angular.module('atex.dam').directive('damInput', function($compile) {
  return {
    restrict : 'EA',
    templateUrl : 'views/dam-input.html',
    scope : {
      label : "=",
      extraLabel : '=',
      model : '=ngModel',
      onChange: '&'
    },
    link : function(scope, element, attrs) {
    }
  };
});
